import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { SchoolService } from "../../../../../shared/services/school.service";
import { DistrictAdministrationService } from "../../../services/districtadministration.service";
import { DistrictCalendarSchoolTableComponent } from "../shared/district-calendar-school-table/district-calendar-school-table.component";
import { CalendarImportColumnTableComponent } from "./calendar-import-column-table/calendar-import-column-table.component";
import { CalendarHolidayImportRequest } from "../shared/calendar-holiday-import-request";
import * as moment from "moment";

@Component({
	selector: "app-district-import-holiday",
	templateUrl: "./district-import-holiday.component.html",
	styleUrls: ["./district-import-holiday.component.css"],
})
export class DistrictImportHolidayComponent implements OnInit {
	constructor(
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private schoolService: SchoolService,
		private districtService: DistrictAdministrationService
	) {}

	ngOnInit(): void {
		this.loadSchools();
	}

	/////////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////////

	OverwriteExisting: boolean = true;
	StartDate: Date = new Date();
	EndDate: Date = new Date();

	SkipFirstLine: boolean = false;
	File: any;
	FileName: string = "";
	TextData: any;
	Format: any;
	lstColumnTable: any = [];
	ShowColumnTable: boolean = false;

	ImportStatusID: number = 0;

	@ViewChild(CalendarImportColumnTableComponent)
	colRef: CalendarImportColumnTableComponent;

	AllSchools: boolean = true;
	lstSchool: any = [];
	SchoolLoading: boolean = false;

	@ViewChild(DistrictCalendarSchoolTableComponent)
	schoolRef: DistrictCalendarSchoolTableComponent;

	Processing: boolean = false;
	errorMessage: string = "";

	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////////

	loadSchools() {
		this.SchoolLoading = true;

		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;

				this.SchoolLoading = false;
			},
			(error) => {
				this.SchoolLoading = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////////

	onUploadFile() {
		this.errorMessage = "";

		document.getElementById("ImportFileInput").click();
	}

	onFileToImportChange(val) {
		this.File = val.target.files[0];
		this.FileName = this.File.name;

		try {
			var fr = new FileReader();
			fr.readAsBinaryString(this.File); //Get string w/ line breaks
			fr.onload = () => {
				this.TextData = fr.result;

				this.ReadFile();
			};
		} catch (e) {
			this.errorMessage = "Invalid File. Accepted formats are: Single Column .txt or .csv, Tab Delimited .txt, Comma Delimited .txt or .csv";
		}
	}

	ReadFile() {
		console.log("TextData");
		console.log(this.TextData);

		this.Format = "Invalid";

		//
		//#region Check File Format by reading file
		//
		this.SetStatus(1);

		var Format = "Invalid";

		var FirstLineEndInd: number = 0;
		FirstLineEndInd = String(this.TextData).indexOf("\n");

		//No newline chars (Only 1 line of data)
		if (FirstLineEndInd < 0) {
			FirstLineEndInd = this.TextData.length;
		}

		var FirstLine = String(this.TextData).substr(0, FirstLineEndInd);

		var ContainsTab = FirstLine.indexOf("\t") > 0;
		var ContainsComma = FirstLine.indexOf(",") > 0;

		if (ContainsTab == false && ContainsComma == false) {
			Format = "SingleLine";
		} else if (ContainsTab == true) {
			Format = "Tab";
		} else if (ContainsTab == false && ContainsComma == true) {
			Format = "Comma";
		} else {
			this.SetStatus(0);
			this.errorMessage = "Invalid File Format";
			return;
		}

		//#endregion
		//

		//
		//#region Parse File into Column Table
		//
		this.SetStatus(2);

		this.lstColumnTable = [];

		var InQuotes: any = false;
		var nextRow: any = [];
		var nextCol: any = "";
		var checkedBOM: boolean = false;
		var StartCol = 0;

		for (var z = 0; z < this.TextData.length; z++) {
			var next = this.TextData[z];

			// console.log(next + ", " + this.TextData.charCodeAt(z));

			if (next == "\n") {
				// console.log("New line");

				nextRow = [...nextRow, nextCol];
				this.lstColumnTable = [...this.lstColumnTable, nextRow];

				nextRow = [];
				nextCol = "";
			} else if (Format == "Tab" && next == "\t") {
				// console.log("Tab");

				nextRow = [...nextRow, String(nextCol)];
				nextCol = "";
			} else if (Format == "Comma" && InQuotes == false && next == ",") {
				// console.log("Comma");

				nextRow = [...nextRow, String(nextCol)];
				nextCol = "";
			} else if (next == '"') {
				// console.log("Quote");

				InQuotes = !InQuotes;
			} else if (next != "\r") {
				nextCol += next;

				// console.log("Normal Char (Format: " + Format + ", Quotes: " + InQuotes + ")");

				//
				// Remove Byte Order Mark from first line
				//
				if (nextRow.length == 0 && checkedBOM == false) {
					if (nextCol.length >= 2 && nextCol.length <= 4) {
						var ClearCol = false;

						//
						// Convert string to Byte array (best way to check for invalid characters)
						//
						var ByteArr: Number[] = [];

						for (var b = 0; b < nextCol.length; b++) {
							var nextChar = Number(nextCol.charCodeAt(b));
							// var nextByte = [nextChar & 0xff, (nextChar / 256) >>> 0];

							ByteArr = [...ByteArr, nextChar];
						}

						// console.log("Byte Arr");
						// console.log(ByteArr);

						if (nextCol.length == 2) {
							//UTF-16 BE
							if (ByteArr[0] == 254 && ByteArr[1] == 255) {
								ClearCol = true;
							}
							//UTF-16 LE
							else if (ByteArr[0] == 255 && ByteArr[1] == 254) {
								ClearCol = true;
							}
						} else if (nextCol.length == 3) {
							//UTF-1
							if (ByteArr[0] == 247 && ByteArr[1] == 100 && ByteArr[2] == 76) {
								ClearCol = true;
							}
							//UTF-7
							else if (ByteArr[0] == 43 && ByteArr[1] == 47 && ByteArr[2] == 118) {
								ClearCol = true;
							}
							//UTF-8
							else if (ByteArr[0] == 239 && ByteArr[1] == 187 && ByteArr[2] == 191) {
								ClearCol = true;
							}
							//SCSU
							else if (ByteArr[0] == 14 && ByteArr[1] == 254 && ByteArr[2] == 255) {
								ClearCol = true;
							}
							//BOCU-1
							else if (ByteArr[0] == 251 && ByteArr[1] == 238 && ByteArr[2] == 40) {
								ClearCol = true;
							}
						} else if (nextCol.length == 4) {
							//UTF-32 BE
							if (ByteArr[0] == 0 && ByteArr[1] == 0 && ByteArr[2] == 254 && ByteArr[3] == 255) {
								ClearCol = true;
							}
							//UTF-32 LE
							else if (ByteArr[0] == 255 && ByteArr[1] == 254 && ByteArr[2] == 0 && ByteArr[3] == 0) {
								ClearCol = true;
							}
							//UTF-EBCDIC
							else if (ByteArr[0] == 221 && ByteArr[1] == 115 && ByteArr[2] == 102 && ByteArr[3] == 115) {
								ClearCol = true;
							}
							//UTF-EBCDIC
							else if (ByteArr[0] == 132 && ByteArr[1] == 49 && ByteArr[2] == 149 && ByteArr[3] == 51) {
								ClearCol = true;
							}
						}

						//
						// Remove the Byte Order Mark
						//
						if (ClearCol == true) {
							nextCol = "";
							checkedBOM = true;
						}
					}
				}
			}
		}

		if (nextCol.length > 0 && nextCol != "\n" && nextCol != "\r") {
			nextRow = [...nextRow, String(nextCol)];
			nextCol = "";
		}
		if (nextRow.length > 0) {
			this.lstColumnTable = [...this.lstColumnTable, nextRow];
		}

		//#endregion
		//

		if (this.SkipFirstLine == true) {
			this.lstColumnTable.shift();
		}

		//
		//#region Get Column Data (Wait for User Input)
		//
		this.SetStatus(3);
		this.ShowColumnTable = true;
		//#endregion
		//

		console.log(this.lstColumnTable);
	}

	SetStatus(num) {
		try {
			if (num >= 0) {
				this.ImportStatusID = num;
				// this.ImportStatusDesc = this.lstImportStatus[num].Desc;
				// this.ImportStatusColor = this.lstImportStatus[num].Color;
			} else {
				this.ImportStatusID = 0;
				// this.ImportStatusDesc = "Error";
				// this.ImportStatusColor = "Red";
			}
		} catch (e) {
			this.ImportStatusID = 0;
			// this.ImportStatusDesc = e.toString();
			// this.ImportStatusColor = "Red";
		}
	}

	onAdd() {
		this.errorMessage = "";
		this.Processing = true;

		var lstCalendarDates: string[] = [];
		var lstOpen: number[] = [];

		if (this.lstColumnTable == undefined || this.lstColumnTable.length == 0) {
			this.errorMessage = "Upload a file with a list of holidays";
			this.Processing = false;
			return;
		}

		var DateColInd = -1;
		var OpenColInd = -1;

		for (var z = 0; z < this.colRef.OptArray.length; z++) {
			var next = this.colRef.OptArray[z];

			if (next == 0 && DateColInd < 0) {
				DateColInd = z;
			}
			if (next == 1 && OpenColInd < 0) {
				OpenColInd = next;
			}
		}

		if (DateColInd < 0) {
			this.errorMessage = "Select which column represents the holiday's date";
			this.Processing = false;
			return;
		}

		for (var z = 0; z < this.lstColumnTable.length; z++) {
			var next = this.lstColumnTable[z];

			var DateInput = next[DateColInd];
			DateInput = moment(new Date(DateInput)).format("MM/DD/YYYY");

			if (DateInput.toLowerCase().indexOf("invalid") != -1) {
				this.errorMessage = "Invalid Date in Row " + (z + 1);

				if (z == 0) {
					this.errorMessage += ". Did you mean to skip the first row and column headers?";
				}

				this.Processing = false;
				return;
			}

			lstCalendarDates = [...lstCalendarDates, DateInput];

			if (OpenColInd > 0) {
				var OpenInput = next[OpenColInd];

				if (OpenInput.toLowerCase() == "yes" || OpenInput.toLowerCase() == "open") {
					lstOpen = [...lstOpen, 1];
				} else {
					lstOpen = [...lstOpen, 0];
				}
			} else {
				lstOpen = [...lstOpen, 0];
			}
		}

		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1) {
			if (this.OverwriteExisting == true) {
				this.errorMessage = "Invalid Start Date";
				this.Processing = false;
				return;
			} else {
				fsDate = moment(new Date()).format("MM/DD/YYYY");
			}
		}
		if (String(feDate).toLowerCase().indexOf("invalid") != -1) {
			if (this.OverwriteExisting == true) {
				this.errorMessage = "Invalid End Date";
				this.Processing = false;
				return;
			} else {
				feDate = moment(new Date()).format("MM/DD/YYYY");
			}
		}

		var lstSID: number[] = [];
		if (this.AllSchools == false) {
			lstSID = this.schoolRef.SelectedSchools.map((school) => school.SchoolID);

			if (lstSID == undefined || lstSID.length == 0) {
				this.errorMessage = "Select schools to update";
				this.Processing = false;
				return;
			}
		}

		var parms: CalendarHolidayImportRequest = {
			lstCalendarDates: lstCalendarDates,
			lstOpen: lstOpen,
			OverwriteExisting: this.OverwriteExisting == true ? 1 : 0,
			StartDate: fsDate,
			EndDate: feDate,
			AllSchools: this.AllSchools == true ? 1 : 0,
			lstSchools: lstSID,
		};

		var Msg = "";
		Msg += "You are about to import " + lstCalendarDates.length + " holidays";

		if (this.OverwriteExisting == true) {
			Msg += " and update normal days between " + fsDate + " and " + feDate + ". Are you sure you want to continue?";
			Msg += " NOTE: This will overwrite any holidays that are not in your import file (that are before " + feDate + ").";
			Msg += " NOTE 2: you will probably want to set the end date to the Last Day of School.";
		} else {
			Msg += ". Are you sure you want to continue?";
		}

		this.confirmationService.confirm({
			key: "importholidayconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: Msg,
			header: "Confirm Import",
			icon: "fa",
			accept: () => {
				this.onFinishAdd(parms);
			},
			reject: () => {
				this.Processing = false;
			},
		});
	}

	onFinishAdd(parms: CalendarHolidayImportRequest) {
		var result = this.districtService.CalendarHolidayImport(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "importholiday",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Holidays were imported successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "importholiday",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update calendar: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////////////

	onSkipFirstLineChange(val) {
		this.SkipFirstLine = val;

		if (this.TextData != undefined && this.TextData.length > 0) {
			this.ReadFile();
		}
	}

	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.SchoolLoading == true || this.Processing == true;
	}

	/////////////////////////////////////////////////////////////////////////
}
